export const SITE_URL: string =
  import.meta.env.VITE_SITE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '');

export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const SITE_DESCRIPTION =
  'Explore AllChinaBuy spreadsheet resources, product finds, seller guides, QC information, shipping costs, reviews and practical China shopping guides — all organized in one place.';

export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';